import { useEffect } from 'react';
import { message } from 'antd';
import { fetchCabinet } from '../api/auth/fetchCabinet';
import { useAuthStore } from '../store/auth/useAuthStore';
import { isHttpError } from 'src/errors/httpErrors';

export function useCabinetBootstrap() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const userCabinetId = useAuthStore((state) => state.userCabinetId);
  const userCabinet = useAuthStore((state) => state.userCabinet);
  const cabinetBootstrapAttempt = useAuthStore((state) => state.cabinetBootstrapAttempt);
  const setUserCabinet = useAuthStore((state) => state.setUserCabinet);
  const setCabinetBootstrapStatus = useAuthStore((state) => state.setCabinetBootstrapStatus);
  const setCabinetBootstrapError = useAuthStore((state) => state.setCabinetBootstrapError);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    // Some authenticated roles do not need a cabinet context, so do not keep the app blocked.
    if (!userCabinetId) {
      setCabinetBootstrapError(undefined);
      setCabinetBootstrapStatus('ready');
      return;
    }

    if (userCabinet?.id === userCabinetId) {
      setCabinetBootstrapError(undefined);
      setCabinetBootstrapStatus('ready');
      return;
    }

    let cancelled = false;

    // Hydrate the cabinet outside the login mutation so a fetch failure never cancels auth.
    setCabinetBootstrapStatus('loading');
    setCabinetBootstrapError(undefined);

    void fetchCabinet(userCabinetId)
      .then((cabinet) => {
        if (!cancelled) {
          setUserCabinet(cabinet);
          setCabinetBootstrapStatus('ready');
        }
      })
      .catch((error) => {
        if (cancelled) {
          return;
        }

        const errorMessage = isHttpError(error)
          ? error.message
          : 'Impossible de charger les informations du cabinet.';

        // Expose the failure to the layout so cabinet-dependent actions can be blocked with retry.
        setUserCabinet(undefined);
        setCabinetBootstrapError(errorMessage);
        setCabinetBootstrapStatus('error');
        message.error(errorMessage);
      });

    return () => {
      cancelled = true;
    };
  }, [
    cabinetBootstrapAttempt,
    isAuthenticated,
    setCabinetBootstrapError,
    setCabinetBootstrapStatus,
    setUserCabinet,
    userCabinet?.id,
    userCabinetId,
  ]);
}
